module.exports = __webpack_public_path__ + "img/1_029.4fe3aa2c.jpg";